import { ITranslateMethod } from '@core/js/hooks/i18n/types';
import React from 'react';
import style from '../index.scss';

type GetRenderProgressBarCellType = {
    translate: ITranslateMethod;
}

export const getRenderProgressBarCell = ({
    translate
}: GetRenderProgressBarCellType) => (name: string, value: string): React.ReactNode => (
    <div className={style.progressWrapper}>
        <div className={`${style.cellName} accordionBodyCellName`}>{translate(name)}</div>
        <div className='accordionBodyCellValue'>
            <div className={style.progressBar}>
                <div className={style.progressIndicator} style={{ width: `${value}%` }}>
                    <div className={style.progressValue}>
                        <span className={style.bonusProgressText}>{`${value}%`}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
);
